import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getControlTokens } from './controlTokens';

function ControlSelect({
  context = 'filterBar',
  width = '100%',
  children,
  sx,
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, context);

  return (
    <Box
      sx={{
        width,
        height: tokens.height,
        minHeight: tokens.height,
        display: 'flex',
        alignItems: 'stretch',
        '& .MuiOutlinedInput-root': {
          height: tokens.height,
          backgroundColor: tokens.surface,
          fontSize: tokens.fontSize,
        },
        '& .MuiSelect-select, & .MuiOutlinedInput-input': {
          fontSize: tokens.fontSize,
          py: context === 'objectToolbar' ? '3px' : '6px',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default ControlSelect;

